var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox page-container" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _vm.handerType == 0 && _vm.orderNo == 0
          ? _c(
              "div",
              {
                staticClass: "flex search-box",
                staticStyle: { "margin-bottom": "40px" },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("div", { staticStyle: { "font-size": "14px" } }, [
                      _vm._v("订单编号："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticStyle: { width: "300px", "margin-right": "50px" },
                      attrs: { clearable: "", placeholder: "请输入订单编号" },
                      model: {
                        value: _vm.searchOrderNo,
                        callback: function ($$v) {
                          _vm.searchOrderNo = $$v
                        },
                        expression: "searchOrderNo",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "pulse-btn",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.searchOrder },
                  },
                  [_vm._v("加载订单")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        (_vm.handerType == 0 && _vm.currentOrderNo != 0) ||
        [1, 2].includes(_vm.handerType)
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.initLoading && _vm.orderInitLoading,
                    expression: "initLoading&&orderInitLoading",
                  },
                ],
                staticClass: "description",
              },
              [
                [
                  _c("div", { staticClass: "title" }, [_vm._v("订单信息")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _vm._l(_vm.orderOption, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.dataIndex,
                            staticClass: "description-term",
                            style: item.widthAll ? "width: 100%" : "",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "flex",
                                style: item.widthAll
                                  ? "align-items: flex-start;"
                                  : "",
                              },
                              [
                                _c("div", { staticClass: "item-title" }, [
                                  _vm._v(_vm._s(item.title) + "："),
                                ]),
                                _vm._v(" "),
                                [
                                  item.isAftersale
                                    ? _c(
                                        "div",
                                        {
                                          style:
                                            "" +
                                            (item.isWarning
                                              ? "color: red"
                                              : "color: #303133"),
                                        },
                                        [
                                          item.dataIndex === "adminReason"
                                            ? [
                                                _vm._v(
                                                  "\n                  \t\t\t" +
                                                    _vm._s(
                                                      _vm.getRejectReason()
                                                    ) +
                                                    "\n                  \t"
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                  \t\t" +
                                                    _vm._s(
                                                      _vm.aftersaleDetails[
                                                        item.dataIndex
                                                      ]
                                                    ) +
                                                    "\n                  \t"
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    : _c("div", {
                                        style:
                                          "" +
                                          (item.isWarning
                                            ? "color: red"
                                            : "color: #303133"),
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.orderDetailInfo[item.dataIndex]
                                          ),
                                        },
                                      }),
                                ],
                              ],
                              2
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.isLypOrderType
                        ? _c("div", { staticClass: "description-term" }, [
                            _c("div", { staticClass: "flex" }, [
                              _c("div", { staticClass: "item-title" }, [
                                _vm._v("商品来源："),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticStyle: { color: "#303133" } }, [
                                _vm._v(_vm._s(_vm.goodsSourceText)),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.remainIntegral !== null &&
                      _vm.remainIntegral !== undefined
                        ? _c("div", { staticClass: "description-term" }, [
                            _c("div", { staticClass: "flex" }, [
                              _c("div", { staticClass: "item-title" }, [
                                _vm._v("用户可用积分："),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticStyle: { color: "#303133" } }, [
                                _vm._v(_vm._s(_vm.remainIntegral)),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                ],
                _vm._v(" "),
                [
                  _c("div", { staticClass: "title" }, [_vm._v("商品选择")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "acea-row mb20" },
                    [
                      _c("SeleceSalegoods", {
                        ref: "SeleceSalegoodsRef",
                        attrs: {
                          saleList:
                            _vm.handerType == 0
                              ? _vm.orderDetailInfo.orderItemList
                              : _vm.aftersaleDetails.skuItems,
                          isDisabled: Boolean(_vm.handerType == 2),
                          isEditable: _vm.handerType === 1,
                          orderNo: _vm.orderNo,
                          aftersaleNo: _vm.aftersaleNo,
                          isCompensationType:
                            _vm.pram && _vm.pram.aftersaleType === 4,
                          needQtyAndAmount: _vm.isNeedQtyAndAmount,
                          showLypFields: _vm.isLypOrderType,
                          showOneCardActivation:
                            Number(_vm.orderDetailInfo.type) === 18,
                          instantDiscountAmount:
                            _vm.orderDetailInfo.instantDiscountAmount || 0,
                        },
                        on: {
                          dataChanged: _vm.handleSaleDataChanged,
                          goToOrderDetail: _vm.goToOrderDetail,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.handerType != 0
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            color: "#606266",
                          },
                        },
                        [
                          _c("div", { staticClass: "flex mb20" }, [
                            _c("div", { staticClass: "item-title" }, [
                              _vm._v("售后原因："),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticStyle: { color: "#303133" } }, [
                              _vm._v(
                                _vm._s(_vm.aftersaleDetails.reason || "--")
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex" }, [
                            _c("div", { staticClass: "item-title" }, [
                              _vm._v("售后凭证："),
                            ]),
                            _vm._v(" "),
                            _vm.aftersaleDetails &&
                            _vm.aftersaleDetails.proofImages &&
                            _vm.aftersaleDetails.proofImages.length
                              ? _c(
                                  "div",
                                  { staticClass: "flex" },
                                  _vm._l(
                                    _vm.aftersaleDetails.proofImages,
                                    function (img, i) {
                                      return _c(
                                        "div",
                                        { key: i },
                                        [
                                          img
                                            ? _c("el-image", {
                                                staticStyle: {
                                                  width: "36px",
                                                  height: "36px",
                                                  margin: "0 15px 15px 0",
                                                },
                                                attrs: {
                                                  src: img,
                                                  "preview-src-list": [img],
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-divider"),
                ],
                _vm._v(" "),
                [0, 1].includes(_vm.handerType)
                  ? [
                      _c("div", { staticClass: "title" }, [_vm._v("售后信息")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "acea-row" },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "createForm",
                              staticStyle: { width: "80%" },
                              attrs: {
                                "label-width": "120px",
                                model: _vm.pram,
                              },
                            },
                            [
                              _vm.handerType == 0
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "售后类型：",
                                        prop: "aftersaleType",
                                        rules: [
                                          {
                                            required: true,
                                            message: "请选择售后类型",
                                            trigger: ["blur", "change"],
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "请选择",
                                          },
                                          on: {
                                            change:
                                              _vm.handleAftersaleTypeChange,
                                          },
                                          model: {
                                            value: _vm.pram.aftersaleType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.pram,
                                                "aftersaleType",
                                                $$v
                                              )
                                            },
                                            expression: "pram.aftersaleType",
                                          },
                                        },
                                        _vm._l(
                                          _vm.filteredSaleTypeOption,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.code,
                                              attrs: {
                                                label: item.description,
                                                value: item.code,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.pram &&
                              (_vm.pram.aftersaleType == null ||
                                (_vm.pram.aftersaleType != 4 &&
                                  _vm.pram.aftersaleType != 2)) &&
                              (_vm.handerType == 0 ||
                                (_vm.handerType == 1 &&
                                  _vm.aftersaleDetails &&
                                  _vm.aftersaleDetails.aftersaleType != 4 &&
                                  _vm.aftersaleDetails.aftersaleType != 2))
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "原路退款信息：",
                                        rules: [
                                          {
                                            required: true,
                                            message: "请完善原路退款信息",
                                            trigger: ["change"],
                                          },
                                        ],
                                      },
                                    },
                                    [
                                      Number(_vm.orderDetailInfo.freight) > 0 &&
                                      !_vm.isMultiMerchantOrder
                                        ? _c(
                                            "div",
                                            { staticClass: "flex mb10" },
                                            [
                                              _c("div", [
                                                _vm._v("是否原路退回运费："),
                                              ]),
                                              _vm._v(" "),
                                              _c("el-checkbox", {
                                                staticStyle: {
                                                  "margin-right": "10px",
                                                },
                                                attrs: { size: "small" },
                                                on: {
                                                  change:
                                                    _vm.handleFreightRefundChange,
                                                },
                                                model: {
                                                  value: _vm.pram.freightRefund,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.pram,
                                                      "freightRefund",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "pram.freightRefund",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("el-input-number", {
                                                staticStyle: { width: "180px" },
                                                attrs: {
                                                  controls: false,
                                                  placeholder: "请输入",
                                                  disabled:
                                                    !_vm.pram.freightRefund,
                                                  min: 0,
                                                  max:
                                                    Number(
                                                      _vm.orderDetailInfo
                                                        .freight
                                                    ) -
                                                    (_vm.orderDetailInfo
                                                      .orderPay &&
                                                    _vm.orderDetailInfo.orderPay
                                                      .freightRefundAmount !==
                                                      undefined
                                                      ? _vm.orderDetailInfo
                                                          .orderPay
                                                          .freightRefundAmount
                                                      : 0),
                                                  precision: 2,
                                                },
                                                model: {
                                                  value:
                                                    _vm.pram
                                                      .freightRefundAmount,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.pram,
                                                      "freightRefundAmount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "pram.freightRefundAmount",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "#999",
                                                    "margin-left": "10px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "最高退还" +
                                                      _vm._s(
                                                        Number(
                                                          _vm.orderDetailInfo
                                                            .freight
                                                        ) -
                                                          (_vm.orderDetailInfo
                                                            .orderPay &&
                                                          _vm.orderDetailInfo
                                                            .orderPay
                                                            .freightRefundAmount !==
                                                            undefined
                                                            ? _vm
                                                                .orderDetailInfo
                                                                .orderPay
                                                                .freightRefundAmount
                                                            : 0)
                                                      ) +
                                                      " | 已退金额：" +
                                                      _vm._s(
                                                        _vm.orderDetailInfo
                                                          .orderPay &&
                                                          _vm.orderDetailInfo
                                                            .orderPay
                                                            .freightRefundAmount !==
                                                            undefined
                                                          ? _vm.orderDetailInfo
                                                              .orderPay
                                                              .freightRefundAmount
                                                          : 0
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isMultiMerchantOrder &&
                                      (Number(_vm.orderDetailInfo.packingFee) >
                                        0 ||
                                        Number(_vm.orderDetailInfo.freight) > 0)
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "mb10",
                                              staticStyle: { color: "#999" },
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t多商户订单部分退款不退打包费和运费；商品全部退完时由系统自动退回剩余打包费和运费。\n\t\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "flex mb10" },
                                        [
                                          _c("div", [_vm._v("现金：")]),
                                          _vm._v(" "),
                                          _c("el-checkbox", {
                                            staticStyle: {
                                              "margin-right": "10px",
                                            },
                                            attrs: { size: "small" },
                                            on: {
                                              change:
                                                _vm.handleCashRefundChange,
                                            },
                                            model: {
                                              value: _vm.pram.cashRefund,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.pram,
                                                  "cashRefund",
                                                  $$v
                                                )
                                              },
                                              expression: "pram.cashRefund",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("el-input-number", {
                                            staticStyle: { width: "180px" },
                                            attrs: {
                                              controls: false,
                                              placeholder: "请输入",
                                              disabled: !_vm.pram.cashRefund,
                                              max: Number(_vm.pram.maxCash),
                                            },
                                            model: {
                                              value: _vm.pram.cash,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.pram, "cash", $$v)
                                              },
                                              expression: "pram.cash",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "#999",
                                                "margin-left": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "最高退还" +
                                                  _vm._s(_vm.pram.maxCash)
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex mb10 fucard-select",
                                          staticStyle: {
                                            "align-items": "flex-start",
                                            "margin-top": "20px",
                                          },
                                        },
                                        [
                                          _c("div", [_vm._v("福豆：")]),
                                          _vm._v(" "),
                                          _c(
                                            "el-checkbox-group",
                                            {
                                              attrs: { size: "small" },
                                              model: {
                                                value: _vm.checkFucard,
                                                callback: function ($$v) {
                                                  _vm.checkFucard = $$v
                                                },
                                                expression: "checkFucard",
                                              },
                                            },
                                            _vm._l(
                                              _vm.fucardLists,
                                              function (item, index) {
                                                return _c(
                                                  "el-checkbox",
                                                  {
                                                    key: index,
                                                    attrs: {
                                                      label: item.fucardId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleFuCardChange(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex mb10",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "margin-right":
                                                                "10px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.name)
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("el-input-number", {
                                                          attrs: {
                                                            controls: false,
                                                            placeholder:
                                                              "请输入",
                                                            min: 0,
                                                            max: Number(
                                                              item.price
                                                            ),
                                                            disabled:
                                                              !item.checked,
                                                          },
                                                          model: {
                                                            value:
                                                              item.refundNum,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "refundNum",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.refundNum",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              color: "#999",
                                                              "margin-left":
                                                                "10px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "最高退还" +
                                                                _vm._s(
                                                                  item.price
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.showReturnShopIntegral
                                        ? _c(
                                            "div",
                                            { staticClass: "flex mb10" },
                                            [
                                              _vm.isReturnShopIntegralBlocked
                                                ? [
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.returnShopIntegralDesc
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                : [
                                                    _c("div", [
                                                      _vm._v("可退积分："),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          color: "#999",
                                                          "margin-left": "10px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.returnShopIntegralDesc
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.handerType == 0 &&
                                      _vm.orderDetailInfo.couponUseResponse &&
                                      _vm.orderDetailInfo.couponUseResponse
                                        .length
                                        ? _c(
                                            "div",
                                            { staticClass: "flex" },
                                            [
                                              _c("div", [_vm._v("卡券：")]),
                                              _vm._v(" "),
                                              _c(
                                                "el-checkbox-group",
                                                {
                                                  attrs: { size: "small" },
                                                  model: {
                                                    value: _vm.pram.couponId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.pram,
                                                        "couponId",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "pram.couponId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.orderDetailInfo
                                                    .couponUseResponse,
                                                  function (item, index) {
                                                    return _c(
                                                      "el-checkbox",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          label: item.couponId,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              item.couponName
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.handerType == 1 &&
                                      _vm.aftersaleDetails
                                        .couponUseResponseList &&
                                      _vm.aftersaleDetails.couponUseResponseList
                                        .length
                                        ? _c(
                                            "div",
                                            { staticClass: "flex" },
                                            [
                                              _c("div", [_vm._v("卡券：")]),
                                              _vm._v(" "),
                                              _c(
                                                "el-checkbox-group",
                                                {
                                                  attrs: { size: "small" },
                                                  model: {
                                                    value: _vm.pram.couponId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.pram,
                                                        "couponId",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "pram.couponId",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.aftersaleDetails
                                                    .couponUseResponseList,
                                                  function (item, index) {
                                                    return _c(
                                                      "el-checkbox",
                                                      {
                                                        key: index,
                                                        attrs: {
                                                          label: item.couponId,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              item.couponName
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.pram && _vm.pram.aftersaleType === 4
                                ? [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "赔付类型：",
                                          prop: "compensationType",
                                          rules: [
                                            {
                                              required: true,
                                              message: "请选择赔付类型",
                                              trigger: ["blur", "change"],
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              placeholder: "请选择赔付类型",
                                            },
                                            model: {
                                              value: _vm.pram.compensationType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.pram,
                                                  "compensationType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "pram.compensationType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.compensationTypeOption,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "福豆赔付：",
                                          prop: "compensationAmount",
                                          rules: [
                                            {
                                              required: true,
                                              message: "请输入福豆赔付数量",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            precision: 2,
                                            step: 0.01,
                                            min: 0.01,
                                            placeholder: "请输入福豆数量",
                                          },
                                          model: {
                                            value: _vm.pram.compensationAmount,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.pram,
                                                "compensationAmount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "pram.compensationAmount",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "赔付说明：",
                                          prop: "compensationRemark",
                                          rules: [
                                            {
                                              required: true,
                                              message: "请输入赔付说明",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: 3,
                                            placeholder: "请输入赔付说明",
                                            resize: "none",
                                          },
                                          model: {
                                            value: _vm.pram.compensationRemark,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.pram,
                                                "compensationRemark",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "pram.compensationRemark",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.handerType == 0 &&
                              (!_vm.pram ||
                                !_vm.pram.aftersaleType ||
                                _vm.pram.aftersaleType !== 4)
                                ? [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "是否审核：",
                                          prop: "isAudited",
                                          rules: [
                                            {
                                              required: true,
                                              message: "请选择是否需要审核",
                                              trigger: ["blur", "change"],
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            attrs: { size: "small" },
                                            model: {
                                              value: _vm.pram.isAudited,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.pram,
                                                  "isAudited",
                                                  $$v
                                                )
                                              },
                                              expression: "pram.isAudited",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 0 } },
                                              [_vm._v("无需审核")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 1 } },
                                              [_vm._v("需要审核")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "售后原因：",
                                          prop: "reason",
                                          rules: [
                                            {
                                              required: true,
                                              message: "请填写售后原因",
                                              trigger: ["blur", "change"],
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: 4,
                                            resize: "none",
                                            placeholder: "售后原因",
                                          },
                                          model: {
                                            value: _vm.pram.reason,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.pram, "reason", $$v)
                                            },
                                            expression: "pram.reason",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "售后凭证：",
                                          prop: "name",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "img-upload" },
                                          [
                                            _vm._l(
                                              _vm.pram.proofImages,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "upload-pic",
                                                    attrs: {
                                                      draggable: "true",
                                                    },
                                                    on: {
                                                      dragstart: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleDragStart(
                                                          $event,
                                                          item
                                                        )
                                                      },
                                                      dragover: function (
                                                        $event
                                                      ) {
                                                        $event.preventDefault()
                                                        return _vm.handleDragOver(
                                                          $event,
                                                          item
                                                        )
                                                      },
                                                      dragenter: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleDragEnter(
                                                          $event,
                                                          item
                                                        )
                                                      },
                                                      dragend: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleDragEnd(
                                                          $event,
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("el-image", {
                                                      staticClass: "image",
                                                      attrs: {
                                                        src: item,
                                                        "preview-src-list":
                                                          _vm.pram.proofImages,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    !_vm.isDisabled
                                                      ? _c("i", {
                                                          staticClass:
                                                            "el-icon-error btndel",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleRemove(
                                                                index
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _vm.pram.proofImages &&
                                            _vm.pram.proofImages.length < 10 &&
                                            !_vm.isDisabled
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "proof-upload-toggle",
                                                    class: {
                                                      "is-active":
                                                        _vm.showProofImageUploader,
                                                    },
                                                    attrs: {
                                                      type: "button",
                                                      title:
                                                        _vm.showProofImageUploader
                                                          ? "收起图片上传"
                                                          : "展开图片上传",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.showProofImageUploader =
                                                          !_vm.showProofImageUploader
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "proof-upload-toggle-inner",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-camera",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.pram.proofImages &&
                                            _vm.pram.proofImages.length < 10 &&
                                            !_vm.isDisabled
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "proof-upload-tip",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t支持上传文件类型：JPG、JPEG、PNG，大小≤5MB；支持粘贴；最多上传10张图片\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.showProofImageUploader &&
                                            _vm.pram.proofImages &&
                                            _vm.pram.proofImages.length < 10 &&
                                            !_vm.isDisabled
                                              ? _c(
                                                  "el-upload",
                                                  {
                                                    staticClass:
                                                      "proof-image-uploader",
                                                    attrs: {
                                                      action: "",
                                                      accept: ".jpg,.jpeg,.png",
                                                      multiple: "",
                                                      "show-file-list": false,
                                                      "http-request":
                                                        _vm.handleProofImageUpload,
                                                      "before-upload":
                                                        _vm.beforeProofImageUpload,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "upLoadPicBox",
                                                        class: {
                                                          "is-dragover":
                                                            _vm.proofImageDragActive,
                                                        },
                                                        attrs: {
                                                          tabindex: "0",
                                                        },
                                                        on: {
                                                          dragenter: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            $event.stopPropagation()
                                                            return _vm.handleProofImageDragEnter(
                                                              $event
                                                            )
                                                          },
                                                          dragover: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            $event.stopPropagation()
                                                          },
                                                          dragleave: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            $event.stopPropagation()
                                                            return _vm.handleProofImageDragLeave(
                                                              $event
                                                            )
                                                          },
                                                          drop: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            $event.stopPropagation()
                                                            return _vm.handleProofImageDrop(
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "upload-drop-zone",
                                                          },
                                                          [
                                                            _vm.proofImageUploadingCount >
                                                            0
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "el-icon-loading upload-icon",
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.proofImageUploadingCount >
                                                                    0
                                                                    ? "正在上传" +
                                                                        _vm.proofImageUploadingCount +
                                                                        "张图片..."
                                                                    : "粘贴或拖拽至这里上传"
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "upload-local-action",
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-plus",
                                                            }),
                                                            _vm._v(
                                                              " 添加本地文件"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "upload-size-tip",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "请上传文件大小≤ 5MB！"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              [0, 1].includes(_vm.handerType)
                                ? [
                                    _vm.handerType == 1 &&
                                    _vm.pram.aftersaleType != 2 &&
                                    _vm.aftersaleDetails.aftersaleType != 2
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "简述：",
                                              prop: "adminReason",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                type: "textarea",
                                                rows: 4,
                                                resize: "none",
                                                placeholder: "简述：",
                                              },
                                              model: {
                                                value: _vm.pram.adminReason,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.pram,
                                                    "adminReason",
                                                    $$v
                                                  )
                                                },
                                                expression: "pram.adminReason",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    ((_vm.pram &&
                                      _vm.pram.aftersaleType &&
                                      [1, 2].includes(
                                        _vm.pram.aftersaleType
                                      )) ||
                                      (_vm.aftersaleDetails &&
                                        _vm.aftersaleDetails.aftersaleType &&
                                        [1, 2].includes(
                                          _vm.aftersaleDetails.aftersaleType
                                        ))) &&
                                    (!_vm.isLypOrderType || _vm.handerType == 0)
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "退货信息：",
                                              prop: _vm.isLypOrderType
                                                ? "backAddressId"
                                                : "supplierAddressRealName",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "请完善退货信息",
                                                  trigger: ["blur", "change"],
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _vm.isLypOrderType
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex mb10",
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            loading:
                                                              _vm.merchantAddressLoading,
                                                            placeholder:
                                                              "请选择取货地址",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.pram
                                                                .pickUpAddressId,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.pram,
                                                                "pickUpAddressId",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "pram.pickUpAddressId",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.merchantAddressOptions,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  label:
                                                                    (item.isDefault ==
                                                                    1
                                                                      ? "默认"
                                                                      : "") +
                                                                    " " +
                                                                    (item.address +
                                                                      item.name +
                                                                      item.detail),
                                                                  value:
                                                                    item.id,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              : [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex mb10",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v("收件人："),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "收件人",
                                                          maxlength: "100",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.pram
                                                              .supplierAddressRealName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.pram,
                                                              "supplierAddressRealName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "pram.supplierAddressRealName",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex mb10",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v("收件电话："),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder:
                                                            "收件电话",
                                                          maxlength: "100",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.pram
                                                              .supplierAddressPhone,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.pram,
                                                              "supplierAddressPhone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "pram.supplierAddressPhone",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex mb10",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v("收件地址："),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder:
                                                            "收件地址",
                                                          maxlength: "100",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.pram
                                                              .supplierAddressDetail,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.pram,
                                                              "supplierAddressDetail",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "pram.supplierAddressDetail",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isLypOrderType &&
                                    _vm.handerType == 0 &&
                                    _vm.pram.aftersaleType &&
                                    [1, 2].includes(
                                      Number(_vm.pram.aftersaleType)
                                    )
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "取件方式：",
                                              prop: "pickUpType",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "请选择取件方式",
                                                  trigger: "change",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  placeholder: "请选择取件方式",
                                                },
                                                model: {
                                                  value: _vm.pram.pickUpType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.pram,
                                                      "pickUpType",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "pram.pickUpType",
                                                },
                                              },
                                              _vm._l(
                                                _vm.pickUpTypeOptions,
                                                function (opt) {
                                                  return _c("el-option", {
                                                    key: opt.value,
                                                    attrs: {
                                                      label: opt.label,
                                                      value: opt.value,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    ((_vm.pram &&
                                      _vm.pram.aftersaleType &&
                                      _vm.pram.aftersaleType == 2) ||
                                      (_vm.aftersaleDetails &&
                                        _vm.aftersaleDetails.aftersaleType ==
                                          2)) &&
                                    (!_vm.isLypOrderType || _vm.handerType == 0)
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "换货收货信息：",
                                              prop: _vm.isLypOrderType
                                                ? "pickUpAddressId"
                                                : "customerAddressRealName",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "请完善换货收货信息",
                                                  trigger: ["blur", "change"],
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _vm.isLypOrderType
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex mb10",
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            loading:
                                                              _vm.merchantAddressLoading,
                                                            placeholder:
                                                              "请选择返件地址",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.pram
                                                                .backAddressId,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.pram,
                                                                "backAddressId",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "pram.backAddressId",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.merchantAddressOptions,
                                                          function (item) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: item.id,
                                                                attrs: {
                                                                  label:
                                                                    (item.isDefault ==
                                                                    1
                                                                      ? "默认"
                                                                      : "") +
                                                                    " " +
                                                                    (item.address +
                                                                      item.name +
                                                                      item.detail),
                                                                  value:
                                                                    item.id,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              : [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex mb10",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v("收件人："),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "收件人",
                                                          maxlength: "100",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.pram
                                                              .customerAddressRealName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.pram,
                                                              "customerAddressRealName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "pram.customerAddressRealName",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex mb10",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v("收件电话："),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder:
                                                            "收件电话",
                                                          maxlength: "100",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.pram
                                                              .customerAddressPhone,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.pram,
                                                              "customerAddressPhone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "pram.customerAddressPhone",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "flex mb10",
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v("收件地址："),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder:
                                                            "收件地址",
                                                          maxlength: "100",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.pram
                                                              .customerAddressDetail,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.pram,
                                                              "customerAddressDetail",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "pram.customerAddressDetail",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.handerType == 1
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "主动通知",
                                              prop: "interfaceTemplate",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                attrs: { size: "small" },
                                                model: {
                                                  value: _vm.pram.notifyType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.pram,
                                                      "notifyType",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "pram.notifyType",
                                                },
                                              },
                                              _vm._l(
                                                _vm.messageOption,
                                                function (item, index) {
                                                  return _c(
                                                    "el-checkbox",
                                                    {
                                                      key: index,
                                                      attrs: {
                                                        label: item.value,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(item.name) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.handerType == 2
                  ? [
                      !_vm.isLypOrderType &&
                      _vm.aftersaleDetails &&
                      _vm.aftersaleDetails.aftersaleType &&
                      [1, 2].includes(_vm.aftersaleDetails.aftersaleType)
                        ? [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("退货信息"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "acea-row" },
                              [
                                _vm._l(_vm.refundMsgOption, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.dataIndex,
                                      staticClass: "description-term",
                                    },
                                    [
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "item-title" },
                                          [_vm._v(_vm._s(item.title) + "：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticStyle: { color: "#303133" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                (_vm.aftersaleDetails
                                                  .supplierAddress &&
                                                  _vm.aftersaleDetails
                                                    .supplierAddress[
                                                    item.dataIndex
                                                  ]) ||
                                                  "--"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.aftersaleDetails.logisticsResponses &&
                                _vm.aftersaleDetails.logisticsResponses.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "description-term",
                                        staticStyle: { width: "100%" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "item-title" },
                                              [_vm._v("退货物流：")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#303133",
                                                  "margin-right": "10px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.aftersaleDetails
                                                      .refundTransportStateStr
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openRefundTransport(
                                                      _vm.aftersaleDetails
                                                        .refundTransportList
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("查看物流 >")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("el-divider"),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isLypOrderType &&
                      _vm.aftersaleDetails &&
                      _vm.aftersaleDetails.aftersaleType == 2
                        ? [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("换货收货信息"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "acea-row" },
                              [
                                _vm._l(_vm.changeMsgOption, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.dataIndex,
                                      staticClass: "description-term",
                                    },
                                    [
                                      _c("div", { staticClass: "flex" }, [
                                        _c(
                                          "div",
                                          { staticClass: "item-title" },
                                          [_vm._v(_vm._s(item.title) + "：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticStyle: { color: "#303133" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                (_vm.aftersaleDetails
                                                  .customerAddress &&
                                                  _vm.aftersaleDetails
                                                    .customerAddress[
                                                    item.dataIndex
                                                  ]) ||
                                                  "--"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.aftersaleDetails
                                  .deliveryLogisticsResponse &&
                                _vm.aftersaleDetails.deliveryLogisticsResponse
                                  .length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "description-term",
                                        staticStyle: { width: "100%" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "item-title" },
                                              [_vm._v("换货物流：")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  color: "#303133",
                                                  "margin-right": "10px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.aftersaleDetails
                                                      .sendTransportStateStr
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openRefundTransport(
                                                      _vm.aftersaleDetails
                                                        .sendTransportList
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("查看物流 >")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("el-divider"),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.aftersaleDetails.compensationRequest
                        ? [
                            _c("div", { staticClass: "title" }, [
                              _vm._v("赔付信息"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "acea-row" }, [
                              _c("div", { staticClass: "description-term" }, [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v("赔付类型："),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { color: "#303133" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getCompensationTypeLabel(
                                            _vm.aftersaleDetails
                                              .compensationRequest
                                              .compensationType
                                          ) || "--"
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v("福豆赔付："),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { color: "#303133" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.aftersaleDetails
                                            .compensationRequest &&
                                            _vm.aftersaleDetails
                                              .compensationRequest
                                              .compensationAmount !== undefined
                                            ? Number(
                                                _vm.aftersaleDetails
                                                  .compensationRequest
                                                  .compensationAmount
                                              ).toFixed(0)
                                            : "--"
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "description-term",
                                  staticStyle: { width: "100%" },
                                },
                                [
                                  _c("div", { staticClass: "flex" }, [
                                    _c("div", { staticClass: "item-title" }, [
                                      _vm._v("赔付说明："),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { color: "#303133" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.aftersaleDetails
                                              .compensationRequest
                                              .compensationRemark || "--"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v("赔付时间："),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { color: "#303133" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.aftersaleDetails
                                            .compensationRequest.createTime ||
                                            "--"
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _c("div", { staticClass: "flex" }, [
                                  _c("div", { staticClass: "item-title" }, [
                                    _vm._v("操作人："),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { color: "#303133" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.aftersaleDetails
                                            .compensationRequest.createBy ||
                                            "--"
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-divider"),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("跟踪日志"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "acea-row" },
                          [
                            _c("SaleLog", {
                              attrs: {
                                trackingLogs: _vm.aftersaleDetails.trackingLogs,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("el-divider"),
                      ],
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [_vm._v("责任判定")]),
                _vm._v(" "),
                [
                  _c(
                    "div",
                    { staticClass: "divBox" },
                    [
                      _c("el-card", { staticClass: "box-card" }, [
                        _c("table", { staticClass: "responsibility-table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { attrs: { width: "120" } }, [
                                _vm._v("责任方"),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "120" } }, [
                                _vm._v("供应商"),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "120" } }, [
                                _vm._v("客户"),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "120" } }, [
                                _vm._v("平台"),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "150" } }, [
                                _vm._v("售后成本"),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("tbody", [
                            _c("tr", [
                              _c("td", [_vm._v("承担比例（百分比）")]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("el-input-number", {
                                    attrs: { disabled: _vm.handerType === 2 },
                                    on: { change: _vm.submitResponsibility },
                                    model: {
                                      value: _vm.supplierPercentage,
                                      callback: function ($$v) {
                                        _vm.supplierPercentage = $$v
                                      },
                                      expression: "supplierPercentage",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("el-input-number", {
                                    attrs: { disabled: _vm.handerType === 2 },
                                    on: { change: _vm.submitResponsibility },
                                    model: {
                                      value: _vm.customerPercentage,
                                      callback: function ($$v) {
                                        _vm.customerPercentage = $$v
                                      },
                                      expression: "customerPercentage",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("el-input-number", {
                                    attrs: { disabled: _vm.handerType === 2 },
                                    on: { change: _vm.submitResponsibility },
                                    model: {
                                      value: _vm.platformPercentage,
                                      callback: function ($$v) {
                                        _vm.platformPercentage = $$v
                                      },
                                      expression: "platformPercentage",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td"),
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [_vm._v("预计金额")]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(_vm.supplierAmount))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(_vm.customerAmount))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(_vm.platformAmount))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.aftersaleCostAmount)),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-content" },
                  [
                    _vm.handerType == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              loading: _vm.loadingInfo.createLoading,
                            },
                            on: { click: _vm.saveCreateSale },
                          },
                          [_vm._v("保存")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.handerType == 1
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              loading: _vm.loadingInfo.examineLoading,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.examineSale(1)
                              },
                            },
                          },
                          [_vm._v("审核成功")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.handerType == 1
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              loading: _vm.loadingInfo.examineLoading,
                            },
                            on: { click: _vm.openRejectDialog },
                          },
                          [_vm._v("审核驳回")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    [1, 2].includes(_vm.handerType)
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              plain: "",
                              type: "primary",
                              loading: _vm.loadingInfo.goNextLoading,
                            },
                            on: { click: _vm.openGoNext },
                          },
                          [_vm._v("添加跟踪")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      { attrs: { type: "link" }, on: { click: _vm.goReturn } },
                      [_vm._v("返回列表")]
                    ),
                  ],
                  1
                ),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("NextState", {
        ref: "NextStateRef",
        on: { doRefresh: _vm.getAftersaleDetail },
      }),
      _vm._v(" "),
      _c("TransportTrace", { ref: "TransportTraceRef" }),
      _vm._v(" "),
      _c("OrderDetail", { ref: "OrderDetailRef" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审核驳回",
            visible: _vm.rejectDialog.visible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.rejectDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.rejectDialog, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "驳回原因",
                    prop: "adminReason",
                    rules: [
                      {
                        required: true,
                        message: "请填写驳回原因",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "100",
                      "show-word-limit": "",
                      placeholder: "请填写驳回原因（最多100字）",
                      resize: "none",
                    },
                    model: {
                      value: _vm.rejectDialog.adminReason,
                      callback: function ($$v) {
                        _vm.$set(_vm.rejectDialog, "adminReason", $$v)
                      },
                      expression: "rejectDialog.adminReason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rejectDialog.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.loadingInfo.examineLoading,
                  },
                  on: { click: _vm.confirmReject },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.integralConfirmDialog.visible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.integralConfirmDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "line-height": "1.8", "font-size": "14px" } },
            [
              _vm._v(
                "本订单为返积分商品，退款需回收对应积分，目前用户积分不足，暂不支持全额退款，请参照系统核算金额处理。"
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.integralConfirmDialog.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }